module.exports = __webpack_public_path__ + "images/questions/qa_title_answers_353655e796073f2cf284c0ecabf4d4c2.png";